import { ConfigData } from '../../../sagas/app/config/config.mapper'
import { NOT_AVAILABLE } from '../../../constants'
import { AvailabilityResponse } from '../../../types'

export interface AppState extends ConfigData {
  appReady: boolean
  availability?: AvailabilityResponse
  error: any
  flowId: string // unique ID for tracing
  saveReturnUrl: string
  sessionExpired: boolean
}

export const initialState: AppState = {
  apiUrl: 'initUrl',
  appReady: false,
  availability: undefined,
  environment: 'INITIAL_VALUE',
  error: {},
  featureFlags: {},
  flowId: '',
  isDevelopment: false,
  isLocalhost: false,
  saveReturnUrl: NOT_AVAILABLE,
  sentry: '',
  sessionExpired: false,
}
